var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14,
    viewBox: "0 0 13 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.308 3.482l-6.826 6.826H1V7.826L7.826 1zM1 12.846h11",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#44486C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })));
}

export default __webpack_public_path__ + "./fonts/edit.fb840189833ffa886073e995d3312c84.svg";
export { SvgEdit as ReactComponent };